import { Vue } from 'vue-property-decorator'

export namespace DocumentsApi {
  /**
   * マニュアル取得API
   *
   * @returns PDFのblobデータ
   */
  export async function getManual(): Promise<Blob> {
    // レスポンスタイプをblobに指定して実行
    const res = await Vue.prototype.$http.get('/content/manual', {
      responseType: 'blob',
    })
    return res.data
  }

  /**
   * 先生用マニュアル取得API
   *
   * @returns PDFのblobデータ
   */
  export async function getManualTeacher(): Promise<Blob> {
    // レスポンスタイプをblobに指定して実行
    const res = await Vue.prototype.$httpWithToken.get('/content/manual/teacher', {
      responseType: 'blob',
    })
    return res.data
  }

  /**
   * 塾管理者用マニュアル取得API
   *
   * @returns PDFのblobデータ
   */
  export async function getManualAcademy(): Promise<Blob> {
    // レスポンスタイプをblobに指定して実行
    const res = await Vue.prototype.$httpWithToken.get('/content/manual/academy', {
      responseType: 'blob',
    })
    return res.data
  }
}
